import CosmosJobsDbRecordBase from '@/models/CosmosJobsDbRecordBase'
export default class CallLogModel extends CosmosJobsDbRecordBase {
  public contactName: string
  public time: string
  public forEmergencyTypeId: number
}
